import loadable from "@loadable/component";

const Product = loadable(() => import("./components/product/provider/provider"));

const routes = [{ path: "/", exact: true, name: "Product", component: Product, title: "CURVED.MONEY" }];

export default routes;